module.exports = __webpack_public_path__ + "images/laboratorio-marques-dalmeida.jpg?17f8461abac11f93b12285cc3b6cf72a";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/laboratorio-marques-dalmeida.jpg
// module id = 981
// module chunks = 0